import React from 'react';
import {
	Row,
	Col,
	Card,
	CardHeader,
	CardBody,
} from 'reactstrap';

export default class SystemEmailTips extends React.Component {
	render() {
		return (
			<Row className={'system-email-tips'}>
				<Col>
					<Card>
						<CardHeader className={'font-weight-bold'}>
							Gợi ý chèn mã dữ liệu vào email
						</CardHeader>
						<CardBody>
							<Row>
								<Col md={6} lg={4} xl={4}>
									<h6>Gợi ý chung</h6>
							        User Name: {'{$user_name}'} <br />
							        Email Address: {'{$user_email}'} <br />
							        Số dư tài khoản: {'{$user_credit}'} <br />
							        Url website: {'{$url}'} <br />
							        Link kích hoạt tài khoản: {'{$link_verify}'} <br />
							        Link đặt lại mật khẩu: {'{$link_forgot_password}'} <br />
							        Token: {'{$token}'} <br />
								</Col>
								<Col md={6} lg={4} xl={4}>
									<h6>Payment</h6>
									Mã giao dịch: {'{$payment_code}'} <br />
							        Số tiền: {'{$payment_amount}'} <br />
							        Thời gian: {'{$payment_time}'} <br />
                                    Tên ngân hàng: {'{$payment_bank_name}'} <br />
							        Tên tài khoản: {'{$payment_account_name}'} <br />
							        Số tài khoản: {'{$payment_account_number}'} <br />
								</Col>
								<Col md={6} lg={4} xl={4}>
									<h6>Product/Order</h6>
									Tên sản phẩm: {'{$product_name}'}<br />
                                    Giá sản phẩm: {'{$product_pricing}'}<br />
                                    Giá: {'{$sub_total}'}<br />
                                    Thành tiền: {'{$total} '}<br />
                                    Số lượng: {'{$qtt} '}<br />
                                    Thời gian tạo: {'{$order_created_at}'}<br />
								</Col>
								<Col md={6} lg={4} xl={4}>
									<h6>VPS - Proxy</h6>
									Username (Services): {'{$services_username}'} <br />
							        Password (Services): {'{$services_password}'} <br />
							        Cấu hình (Services): {'{$vps_config}'} <br />
							        Hệ điều hành: {'{$os}'} <br />
                                    Port: {'{$port}'} <br />
							        Bang: {'{$state}'} <br />
							        Ip: {'{$ip}'} <br />
							        Thời gian thuê: {'{$billing_cycle}'} <br />
							        Ngày kết thúc: {'{$next_due_date}'} <br />
							        Ngày đặt hàng: {'{$order_created_at}'} <br />
								</Col>
                                <Col md={6} lg={4} xl={4}>
									<h6>Hosting</h6>
									Username (Services): {'{$services_username}'} <br />
							        Password (Services): {'{$services_password}'} <br />
                                    Url control panel: {'{$url_control_panel}'} <br />
                                    IP control panel: {'$ip_address_cp'} <br />
							        Domain: {'{$domain}'} <br />
							        Thời gian thuê: {'{$billing_cycle}'} <br />
							        Ngày kết thúc: {'{$next_due_date}'} <br />
							        Ngày đặt hàng: {'{$order_created_at}'} <br />
								</Col>
								<Col md={6} lg={4} xl={4}>
									<h6>Đổi IP</h6>
									IP cũ: {'{$ip_old}'} <br />
        							IP mới: {'{$ip_new}'} <br />
								</Col>
								<Col md={6} lg={4} xl={4}>
									<h6>Addon VPS</h6>
                                    <div className="text-danger">
                                        Cấu hình Addon gồm cầu hình (Tên sản phẩm, số lượng, giá) và chỉ hiện khi addon cpu-ram-disk lớn hơn 0
                                    </div>
                                    Cấu hình Addon CPU: {'{$addon_cpu}'} <br />
                                    Cấu hình Addon RAM: {'{$addon_ram}'} <br />
                                    Cấu hình Addon DISK: {'{$addon_disk}'} <br />
        							Thời gian: {'{$addon_time}'} <br />
								</Col>
                                <Col md={6} lg={4} xl={4}>
									<h6>Upgarde Hosting</h6>
                                    Gói trước nâng cấp: {'{$before_product_name}'} <br />
                                    Gói sau nâng cấp: {'{$after_product_name}'} <br />
								</Col>
                            </Row>
						</CardBody>
					</Card>
				</Col>
			</Row>
		)
	}
}